import gsap from 'gsap'
import Base from '../../../src/js/classes/Base'

export default class PostsGrid extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				form: '#product-filters',
				resultsContainer: '#product-results',
				filterReset: '.filter-reset',
				filterButton: '.s-PostsGrid__nav__filters__label',
				filters: '.s-PostsGrid__nav__filters',
				content: '.s-PostsGrid__nav__filters__content',
			},
			options: {},
			classes: {
				active: 'active',
				isFiltering: 'is-filtering',
				open: 'open',
				close: 'close',
			},
			state: {},
		})
	}

	init() {
		this.addEvents()
	}

	updateProducts() {
		const formData = new FormData(this.elements.form)
		const params = new URLSearchParams(formData)

		// Update the URL with new filters
		history.pushState(null, '', `?${params.toString()}`)

		// Use Barba.js to load filtered content
		window.barba.go(`?${params.toString()}`)
	}

	onClickFilterButton() {
		// Open, let's close
		if (this.elements.filters.classList.contains(this.classes.isFiltering)) {
			this.elements.filterButton.classList.remove(this.classes.open)
			this.elements.filterButton.classList.add(this.classes.close)
			gsap.to(this.elements.content, {
				height: 0,
				duration: 0.5,
				ease: 'inOut',
				onComplete: () => {
					this.elements.filters.classList.remove(this.classes.isFiltering)
				},
			})
		} else {
			this.elements.filterButton.classList.add(this.classes.open)
			this.elements.filterButton.classList.remove(this.classes.close)
			gsap.to(this.elements.content, {
				height: 'auto',
				duration: 0.5,
				ease: 'inOut',
				onComplete: () => {
					this.elements.filters.classList.add(this.classes.isFiltering)
				},
			})
		}
	}

	addEvents() {
		this.elements.form.addEventListener('change', this.updateProducts.bind(this))
		this.elements.filterButton.addEventListener('click', this.onClickFilterButton.bind(this))
	}

	removeEvents() {}

	resize() {}

	update() {}

	unmount() {}
}
